<template>
  <nav id="userNav" class="navbar navbar-expand-lg navbar-light flex-row" aria-label="User Specific Navigation">
    <router-link class="logo-text" to="/" exact>
        <!--<span class="flex-left logo">HERMERTIA WARS</span>-->
        <svg-icon-container
            class="flex-left logo"
            focusable="false" 
            :icon="'logoHorizontal'">
        </svg-icon-container>
    </router-link>
    <div class="flex-row flex-right btn-container">
      <!--<button class="btn btn-outline-default">Button</button>-->
        <a class="btn btn-outline-default flex-right btn-white" href="/#about">
            ABOUT
        </a>
        <router-link class="btn btn-outline-default flex-right btn-white" as="button" :to="{ name: 'AmadorHeroProfile'}">
            HEROES
        </router-link>
        <router-link class="btn btn-outline-default flex-right btn-white" as="button" :to="{ name: 'News'}">
            NEWS
        </router-link>
    </div>
    <button class="navbar-toggler navbar-burger"
            type="button"
            @click="toggleSidebar"
            :aria-expanded="$sidebar.showSidebar"
            aria-label="Toggle mobile navigation">
      <span class="navbar-toggler-bar"></span>
      <span class="navbar-toggler-bar"></span>
      <span class="navbar-toggler-bar"></span>
    </button>
  </nav>
</template>
<script>
import {SvgIconContainer} from "@/components";

export default {
  components: {
    SvgIconContainer
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.showSidebar = !this.$sidebar.showSidebar;
    },
    hideSidebar() {
      this.$sidebar.showSidebar = false;
    },
  }
};
</script>
<style>
</style>
